import { useState } from 'react'
import { useEventList } from 'src/api/event'
import { withLoginUser } from 'src/api/user'
import { EventsLayout } from './EventsLayout'

export const EventTop = withLoginUser(({ user }) => {
  const [pageIndex, setPageIndex] = useState(1)
  const eventsData = useEventList({}, pageIndex)

  const { events = [], eventTotal = 0 } = eventsData.data || {}

  return (
    <EventsLayout
      user={user}
      events={events}
      pageIndex={pageIndex}
      eventTotal={eventTotal}
      setPageIndex={setPageIndex}
      pageTitle={'『ONLYSTORY』会員様限定イベント'}
    />
  )
})
